import WishlistComponent from '../components/wishlist';

const Wishlist = () => {
  return <WishlistComponent />;
};

export default Wishlist;

export async function getStaticProps({ preview = false }) {
  return {
    props: { preview },
  };
}
